<template>
     <Table border :columns="columns"
    :data="tableData"
    @on-selection-change="handleSelect"
    :draggable="attrs.draggable"
    @on-drag-drop="onDragDrop"></Table>
</template>
<script>
    /**
     * table容器组件
     *
     * 2020-09-18 modify by wxf
     * 增加根据条件判断列是否显示
     *
     * 2020-11-9 modify by wxf
     * 表单增加拖拽排序功能，目前只能用put方式更新
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompSendMixin from '@/utils/compSend.mixin'
    export default {
        name: 'LyTable',
        mixins: [CompEventMixin, CompSendMixin],
        data () {
            return {
                /**
                 * 这里显示的数组，和改变的数组不能为同一个，
                 * 所以用一个中间数据变量，来存放改变的值。上传也就用这个中间变量
                 */
                tempArray: [],
                sortId: [] // 排序id
            }
        },
        computed: {
            columns () {
                let arr = []
                let actions = [] // 操作按钮的存放
                if (this.attrs.children) {
                    this.attrs.children.forEach(el => {
                        if (el.type == 'action') { // 按钮的处理
                            actions.push(el)
                        } else {
                            // 表格列配置
                            let col = {
                                ...el,
                                key: el.field,
                                render: (h, params) => {
                                    return (
                                        <el.name attrs={el} row={params.row} value={this.page[params.index][el.field]} onInput={ (val) => {
                                            this.handleInput(val, params.index, el.field)
                                        }} ></el.name>
                                    )
                                }
                            }
                            if(el.width && el.width > 0) {
                                col['width'] = parseInt(el.width)
                            }
                            if (el.type == 'selection'|| el.type == 'index' ||(el.hasOwnProperty('title') && el.title.length > 0)) { // 增加根据条件判断列是否显示 (序号列特殊判断处理) 2020-09-18 wxf
                                arr.push(col)
                            }
                        }
                    });
                }
                if (actions.length > 0) {
                    arr.push({
                        title: '操作',
                        key: 'action',
                        fixed: 'right',
                        render: (h, params) => {
                            let btns = []
                            actions.forEach((el) => {
                                // 将当前行作为数据，组装过去
                                // el.rowData = params.row
                                btns.push(
                                    <ly-hoc style="margin-right: 5px;" attrs={el} row={params.row}></ly-hoc>
                                )
                            })
                            return (
                                <div>
                                    {btns}
                                </div>
                            )
                        }
                    })
                }
                return arr
            },
            /**
             * 表格的数据
             */
            tableData () {
                let arr =  Array.isArray(this.page) ? this.page : []
                this.tempArray = JSON.parse(JSON.stringify(arr))
                //iview Table中为0的数据需要转换成字符串才能显示 2021-4-14 by wxf
                let arrRes = arr.map((item) => {
                    for(let k in item) {
                        if(item[k] === 0) {
                            item[k] = item[k].toString()
                        }
                    }
                    return item
                })
                return arrRes
            }
        },
        methods: {

            /**
             * 有组件要提交数据的监听
             * 这里将数据验证过后，发送要提交的数据
             */
            handleGiveMeSubmitData () {
                if (this.attrs.isSubmit) {
                    // 发送需要提交的数据
                    this.sendSubmitData(this.tempArray)
                }
            },
            /**
             * 输入的箭头
             * @param val 输入的值
             * @param index 所在行数
             * @param field 要改变的字段
             */
            handleInput (val, index, field) {
                this.tempArray[index][field] = val
            },
            /**
            * 监听列表的选中项
            * @param selectLists 返回已选择项
            */
            handleSelect (selectLists) {
                let selectIds = []
                selectLists.forEach((el, index) => {
                    selectIds.push(el.id)
                })
                // 2021 8 30 wxq 批量选择之后计算总和  需要列表传送整个数据
                if(this.attrs.batchobjs){
                  this.sendBatchData(selectLists)
                }else{
                  this.sendBatchData(selectIds)
                }

            },
            /**
             *  拖拽
             *  @author wxf
             *  @time 2020-11-9
             */
            onDragDrop(start, end) {
                //转成int型，方便后续使用
                start = parseInt(start)
                end = parseInt(end)
                this.sortId = this.tableData.map((el) => {
                    return el.id
                })
                this.dataUpdate(start, end, this.sortId) // id顺序更新
                // 获取api
                let path = this.attrs.dragApi
                let url = this.$path.getPath(path, this.page)
                if (url.indexOf('undefined') > 0) {
                    path = this.$path.getPath(path, this.$route.params)
                } else {
                    path = url
                }
                // 拖拽更新
                this.$api.save(path, {content: this.sortId}).then(() => {
                    this.dataUpdate(start, end, this.tableData) // 数据视图更新
                    this.$Message.success('操作成功')
                }).catch((err) => {
                    console.error(err)
                    this.$Message.error({content: err, duration: 5 })
                })
            },
            /**
             * 数据更新
             * typeStr id 或 data
             */
            dataUpdate (start, end, typeStr) {
                let tmp = typeStr[start]
                if(start < end) {
                    for(var i = start + 1; i <= end; i++) {
                        typeStr.splice(i-1, 1, typeStr[i])
                    }
                    typeStr.splice(end, 1, tmp)
                }
                if(start > end) {
                    for(var i = start; i > end; i--) {
                        typeStr.splice(i, 1, typeStr[i-1])
                    }
                    typeStr.splice(end, 1, tmp)
                }
                this.$set(this, 'page', this.tableData) // 修复拖拽排序视图不更新 2021-06-09
            }
        }
    }
</script>
<style>
.ivu-table-cell button {
    margin-right: 5px;
}
.ivu-table-cell {
    overflow:inherit !important;
    padding-top: 5px;
    padding-bottom: 5px;

}
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/table/src/index.vue